<template>
  <div
    class="app app1 app--1 lp-section width-expand padding-2xl-vertical l:padding-max-vertical"
    :class="`bg-${backgroundColor} c-${textColor}`"
    :id="`App1-${pageUid}`">
    <div
      class="margin-auto-inline main-container container container-l section-container">
      <div class="content-block width-expand">
        <div class="content-top flex gap-xl flex-stretch margin-2xl-bottom">
          <a
            v-if="logo.show"
            :href="logo.href"
            target="blank"
            class="logo"
            @click.prevent="
              track('app1|logo|click', { value: logo.alt }).then(
                logo.navigationHandler
              )
            ">
            <img :src="logo.finalSrc" class="media-block-image"
          /></a>
          <div class="separator"></div>
          <div class="content c-alt">
            <div class="main-title">
              <span
                class="first-word margin-s-inline-end"
                :class="`c-${titleFirstWordColor}`">
                {{ firstTitleWord }}
              </span>
              <span class="main-title">
                {{ titleWordsExcludingFirstAndLast }}
              </span>
              <span
                class="last-word margin-s-inline-start"
                :class="`c-${titleLastWordColor}`">
                {{ lastTitleWord }}
              </span>
            </div>
            <div
              class="main-text margin-m-top"
              :class="`c-${text}`"
              v-if="text">
              <span class="c-alt">
                {{ text }}
              </span>
            </div>
          </div>
        </div>

        <div class="slider-external-wrapper relative flex">
          <div
            :class="`bg-${sliderMainSeparatorsColor}`"
            class="slider-separator margin-m-inline-end" style="width:3px; height: 60px;"></div>
          <slider
            class="feature-slider width-expand"
            :config="sliderConfig"
            :navigation-outside="true"
            navigation-theme-type="minimal">
            <slide v-for="item in sliderItems" class="app-item-slide" style="max-width:210px;">
              <div class="flex flex-middle gap-m padding-m">
                <img :src="item.image" :alt="item.text" style="max-height: 50px;height: auto; width: auto;" />
                <span class="text-l" style="max-width: 140px;line-height: 0.8;">{{item.text}}</span>
                <div class="slide-separator margin-s-inline"
                     :class="`bg-${sliderSeparatorsColor}`"
                     style="height: 34px; width: 2px;"></div>
              </div>
            </slide>
          </slider>
          <div
            :class="`bg-${sliderMainSeparatorsColor}`"
            class="slider-separator margin-m-inline-start" style="width:3px; height: 60px; "></div>
        </div>

        <div
          class="app-download-links flex gap-l l:visible"
          v-if="downloadImageLink.show || downloadImageLink2.show">
          <a
            @click.prevent="
              track('app1|downloadImage|click', {
                value: downloadImageLink.alt,
              }).then(downloadImageLink.navigationHandler)
            "
            :href="downloadImageLink.href"
            target="_blank">
            <img :src="downloadImageLink.finalSrc"
          /></a>
          <a
            @click.prevent="
              track('app1|downloadImage2|click', {
                value: downloadImageLink2.alt,
              }).then(downloadImageLink2.navigationHandler)
            "
            :href="downloadImageLink2.href"
            target="_blank">
            <img :src="downloadImageLink2.finalSrc"
          /></a>
        </div>
      </div>
      <div class="media-block width-expand flex-middle flex-center" v-if="mainImage.show">
        <img
          :src="mainImage.finalSrc"
          :alt="mainImage.alt"
          class="media-block-image" />
      </div>
      <div
        class="app-download-links flex-center flex-wrap gap-l margin-xl-top l:hidden">
        <a
          @click.prevent="
              track('app1|downloadImage|click', {
                value: downloadImageLink.alt,
              }).then(downloadImageLink.navigationHandler)
            "
          :href="downloadImageLink.href"
          target="_blank">
          <img :src="downloadImageLink.finalSrc"
          /></a>
        <a
          @click.prevent="
              track('app1|downloadImage2|click', {
                value: downloadImageLink2.alt,
              }).then(downloadImageLink2.navigationHandler)
            "
          :href="downloadImageLink2.href"
          target="_blank">
          <img :src="downloadImageLink2.finalSrc"
          /></a>
      </div>
    </div>
  </div>
</template>

<script>
import useUiElements from "@/client/extensions/composition/useUiElements";
import lpSectionMixin from "@/client/applications/meitavlp/extensions/mixins/lpSection";
import { inject } from "vue";

export default {
  mixins: [lpSectionMixin],

  setup(props) {
    let pageUid = inject("pageUid");

    let schema = {
      title: "",
      text: "",
      logo: {},
      mainImage: {},
      downloadImageLink: {},
      downloadImageLink2: {},
      sliderItems: {
        image: "",
        text: "",
      },
      backgroundColor: "",
      textColor: "",
      titleFirstWordColor: "",
      titleLastWordColor: "",
      sliderMainSeparatorsColor: "",
      sliderSeparatorsColor: "",
      sliderControlsColor: "",
    };
    let overloadedProps = useUiElements({ input: props.sectionData }).props;
    return {
      ...schema,
      ...overloadedProps,
      allData: overloadedProps,
      pageUid,
      trackEvent: inject("trackEvent"),
      track: inject("track"),
      triggerSectionsEvent: inject("triggerSectionsEvent"),
    };
  },
  data: function () {
    return {
      sliderConfig: {
        loop: true,
        slidesPerView: "auto",
        centeredSlides: false,
        centerInsufficientSlides: true,
        centeredSlidesBounds: false,
        autoplay: {
          delay: 2500,
          disableOnInteraction: true,
        },
        spaceBetween: 0,
        breakpoints: {
          767: {
            //   slidesPerView: "auto",
          },
          600: {
            // slidesPerView: 1,
          },
        },
        pagination: false,
        observer: true,
        observeParents: true,
        parallax: true,

      },
    };
  },
  computed: {
    firstTitleWord() {
      return this.title.split(" ")[0];
    },
    lastTitleWord() {
      let split = this.title.split(" ");
      return split[split.length - 1];
    },
    titleWordsExcludingFirstAndLast() {
      let words = this.title.split(" ");
      words.shift();
      words.pop();
      return words.join(" ");
    },
  },
  methods: {
    async testMethod() {
      return true;
    },
  },
};
</script>

<style scoped lang="scss">
.app1 {
  .main-container {
    display: flex;
    justify-content: space-between;
    align-items: stretch;
    gap: var(--margin-max);

    @media (max-width: 1024px) {
      flex-direction: column;
      gap: var(--margin-l);
      align-items: center;
    }
  }

  .media-block-image {
    height: auto;
    max-height: 480px;
    max-width: 100%;
    margin: auto;

    @media (max-width: 1024px) {
      max-height: 250px;
    }
  }

  .content-block {
    max-width: 50%;
    min-width: 660px;

    @media (max-width: 600px) {
      min-width: 0;
      max-width: 100%;
      text-align: center;
      flex-direction: column;
      align-items: center;
    }

    .content-top {
      display: flex;
      align-items: stretch;

      @media (max-width: 767px) {
        flex-direction: column;
        align-items: center;
        text-align: center;
      }
    }

    .logo {
      display: block;
      height: 150px;
      width: 190px;

      .img {
        height: auto;
        max-width: 100%;
        margin: auto;
      }
    }

    .separator {
      position: relative;
      height: 130px;
      top: 10px;
      width: 3px;
      flex: 0 0 3px;
      background-color: var(--c-alt);
      @media (max-width: 1024px) {
         display: none;
      }

    }

    .main-title,
    .main-title span {
      line-height: 0.8;
      letter-spacing: -1px;
      font-weight: bold;
      font-size: calc(var(--font-3xl) * 1.2);

      @media (max-width: 767px) {
        line-height: 0.75;
        letter-spacing: -0.92px;
        font-size: calc(var(--font-3xl) * 1);
      }
    }

    .main-text,
    .main-text span {
      line-height: 1;
      font-size: var(--font-2xl);
    }
  }

  .app-download-links {
    a {
      display: flex;
      height: 46px;
      max-height: 46px;

      img {
        max-height: 100%;
        width: auto;
      }
    }
  }

  :deep(.swiper-button--minimal.swiper-button-prev) {
    position: absolute;
    top: 80px!important;
    inset-inline-end: 0!important;
    height: 20px!important;
    &::after {
      font-size: 16px!important;
    }
  }
  :deep(.swiper-button--minimal.swiper-button-next) {
    position: absolute;
    top: 80px!important;
    inset-inline-end: 20px!important;
    inset-inline-start: auto!important;
    height: 20px!important;
    &::after {
      font-size: 16px!important;
    }

    @media (max-width: 767px) {
      inset-inline-end: auto!important;
      inset-inline-start: 0!important;
    }
  }
  .slider-external-wrapper {
    margin-top: var(--margin-l);
    margin-inline: 10px;
    margin-bottom: var(--margin-2xl);
    @media (max-width: 500px) {
      height: 70px;
    }
  }

  .swiper-pagination {
    --swiper-pagination-color: var(--c-alt);
    position: relative;
    top: 0px;
  }

  // slider nav
  .slider-nav {
    position: absolute;
    inset-inline-end: -6px;
    top: calc(100% + 8px);
    height: fit-content;

    .swiper-button-disabled {
      pointer-events: none;
    }

    .swiper-button-prev,
    .swiper-button-next {
      position: static;
      top: 0;
      margin: 0;
      transform: rotate(180deg);
      height: 20px;
      width: 12px;

      &::after {
        font-size: 14px;
        font-weight: bold;
        color: var(--c-text);
      }
    }

    .swiper-button-prev {
      &::after {
      }
    }

    .swiper-button-next {
      &::after {
      }
    }
  }
}
</style>
